export default "__VITE_ASSET__DXJ4b7JU__"